import type { FieldValues, Path, UseFormRegister } from 'react-hook-form';
import { BasicInputStyles } from './BasicInput';
import type { InputHTMLAttributes } from 'react';
import type { Merge } from 'simplytyped';
import styled from 'styled-components';

const Input = styled(BasicInputStyles)``;

type InputNumberProps<Fields extends FieldValues> = Merge<
  InputHTMLAttributes<HTMLInputElement>,
  {
    id?: string;
    errorMessage?: string;
    name: Path<Fields>;
    register?: UseFormRegister<Fields>;
    label?: string;
    inputSize?: string;
  }
>;

export const InputNumber = <Fields extends FieldValues>(
  props: InputNumberProps<Fields>
) => {
  const {
    id,
    errorMessage,
    name,
    inputSize = '',
    register = () => null,
    label
  } = props;
  return (
    <Input
      id={id ? `${id}-input` : undefined}
      errorMessage={errorMessage}
      inputSize={inputSize}
      alt={label}
      {...props}
      type="number"
      {...register(name, {
        setValueAs: (value) =>
          value === undefined || value === '' ? undefined : parseFloat(value)
      })}
    />
  );
};
